"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('chest', false, function (props) {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.9968 3.5C16.9968 5.76563 16.9968 7.48184 16.9968 8.64861C16.9968 10.3988 16.0333 11.0735 12.4023 12.0065C8.77133 12.9394 7.69632 13.4893 6.84816 15.0995C6.28272 16.1729 6 17.8303 6 20.0715V37.5",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M34.9416 21.5085C35.1792 24.3854 34.6917 26.8978 33.4792 29.046C32.2667 31.1941 30.126 32.5026 27.0572 32.9716",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.0587 21.5085C12.82 24.3854 13.3096 26.8978 14.5277 29.046C15.7457 31.1941 17.9038 32.5026 21.0022 32.9716",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13 43.5121C14.3333 41.957 15 40.2662 15 38.4396C15 36.613 15 33.8253 15 30.0764",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M35 43.5121C33.6667 41.957 33 40.2662 33 38.4396C33 36.613 33 33.8253 33 30.0764",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M31.0003 3.5C31.0003 5.76563 31.0003 7.48184 31.0003 8.64861C31.0003 10.3988 31.9638 11.0735 35.5948 12.0065C39.2257 12.9394 40.3008 13.4893 41.1489 15.0995C41.7144 16.1729 41.9971 17.8303 41.9971 20.0715V37.5",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }));
});

exports.default = _default;